import React from 'react';
import './ReadyTo.css';

const ReadyTo = () => {
  return (
    <div className='container'>
      <div className='content-wrapper'>
        <div className='content-box'>
          <div className='content-inner'>
            <h2 className='main-heading'>
              Ready to Elevate your <br/> brand to <i style={{ fontFamily: 'instrument-serif' }}>new heights?</i>
            </h2>
            <p
              className='subtext'
              style={{
                color: '#9c9c9c',
                fontSize: '1rem',
                lineHeight: '1.5rem',
                fontWeight: 'var(--framer-font-weight)',
                textAlign: 'center',
                fontFamily: 'var(--framer-font-family)',
              }}
            >
              Let’s Talk
            </p>
          </div>
          <div className='button-wrapper-ready'>
            {/* <a
              style={{ textDecoration: 'none' }}
              className='primary-button'
              href='https://calendly.com/futureethicsmedia/30min'
              target='_blank'
              rel='noopener noreferrer'
            >
              Book a Call
            </a> */}

            <iframe className="calendly-inline-widget" src="https://calendly.com/futureethicsmedia/30min" ></iframe>
            
          </div>
        </div>
      </div>
      <div className='glow-effect'>
        <div className='blur-circle'>
          <div className='conic-gradient' />
        </div>
        <div className='blur-circle-small'>
          <div className='small-gradient' />
        </div>
      </div>
    </div>
  );
};

export default ReadyTo;
